import React from 'react';

import FlexibleProductEditView from '@components/shared/flexible_products/FlexibleProductEditView';
import PageHeader from '@shared/PageHeader';
import { useTranslation } from 'react-i18next';

import adminFlexibleProductService from '@services/admin/flexibleProductService';
import adminProductService from '@services/admin/productService';

export default function AdminFlexibleProductNew() {
  const { t } = useTranslation();
  return (
    <div>
      <PageHeader basePath="/admin" items={['products', 'products.flexible', { label: t('common.button.create') }]} />
      <FlexibleProductEditView
        flexibleProductService={adminFlexibleProductService}
        productService={adminProductService}
        role="admin"
      />
    </div>
  );
}
